import Vue from 'vue'
import Store from '@/store/index.ts';
import VueRouter, { RouteConfig } from 'vue-router'
import Portfolios from '@/pages/portfolios.vue';
import ManagePortfolios from '@/pages/portfolios/manage.vue';
import ComparePortfolios from '@/pages/portfolios/compare.vue';
import Aircraft from "@/pages/aircraft.vue";
import PortfolioReport from "@/pages/portfolios/report.vue";
import AircraftCertificate from "@/components/certificates/aircraftCertificate.vue";
import PortfolioCertificate from "@/components/certificates/portfolioCertificate.vue";
import Checkout from "@/pages/checkout.vue";
import Thankyou from "@/pages/thankyou.vue";
import Login from "@/pages/login.vue";
import AboutTheCalculator from '@/pages/aboutTheCalculator.vue';
import ContactUs from '@/pages/contactUs.vue';
import ForgotPassword from '@/pages/forgotPassword.vue';
import ResetPassword from '@/pages/resetPassword.vue';
import Instructions from '@/pages/instructions.vue';
import Demo from '@/pages/demo.vue';
import Pricing from '@/pages/pricing.vue';
import HasAgreed from '@/pages/hasAgreed.vue';
import Results from '@/pages/results.vue';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
	{
		path: "/",
		redirect: "/aircraft"
	},
	{
		path: '/login',
		name: 'Login',
		component: Login,
		meta: {
			title: 'Login - AWG Carbon Calculator',
		}
	},
	{
		path: '/forgotPassword',
		name: 'ForgotPassword',
		component: ForgotPassword,
		meta: {
			title: 'Forgot Password - AWG Carbon Calculator',
		}
	},
	{
		path: '/resetPassword/:code',
		name: 'ResetPassword',
		component: ResetPassword,
		props: true,
		meta: {
			title: 'Reset Password - AWG Carbon Calculator',
		}
	},
	{
		path: '/portfolio',
		name: 'Portfolios',
		component: Portfolios,
		meta: {
			title: 'Portfolios - AWG Carbon Calculator',
		}
	},
	{
		path: '/portfolio/manage/:PortfolioId',
		name: 'ManagePortfolios',
		component: ManagePortfolios,
		props: true,
		meta: {
			title: 'Manage Portfolios - AWG Carbon Calculator',
		}
	},
	{
		path: '/portfolio/:idOne/:idTwo/compare',
		name: 'ComparePortfolios',
		component: ComparePortfolios,
		props: true,
		meta: {
			title: 'Compare Portfolios - AWG Carbon Calculator',
		}
	},
	{
		path: '/portfolio/:PortfolioId/report',
		name: 'PortfolioReport',
		component: PortfolioReport,
		props: true,
		meta: {
			title: 'Portfolio Report - AWG Carbon Calculator',
		}
	},
	{
		path: '/portfolio/certificate',
		name: 'PortfolioCertificate',
		component: PortfolioCertificate,
		meta: {
			title: 'Portfolio Certificate - AWG Carbon Calculator',
		}
	},
	{
		path: '/aircraft/certificate',
		name: 'AircraftCertificate',
		component: AircraftCertificate,
		meta: {
			title: 'Aircraft Certificte - AWG Carbon Calculator',
		}
	},
	{
		path: '/aircraft',
		name: 'Aircraft',
		component: Aircraft,
		meta: {
			title: 'Aircraft - AWG Carbon Calculator',
		}
	},
	{
		path: '/checkout',
		name: 'Checkout',
		component: Checkout,
		meta: {
			title: 'Checkout - AWG Carbon Calculator',
		}
	},
	{
		path: '/thankyou',
		name: 'Thankyou',
		component: Thankyou,
		meta: {
			title: 'Thank You - AWG Carbon Calculator',
		}
	},
	{
		path: '/about',
		name: 'About',
		component: AboutTheCalculator,
		meta: {
			title: 'About the calculator - AWG Carbon Calculator',
		}
	},
	{
		path: '/results',
		name: 'Results',
		component: Results,
		meta: {
			title: 'Results - AWG Carbon Calculator',
		}
	},
	{
		path: '/contactus',
		name: 'ContactUs',
		component: ContactUs,
		meta: {
			title: 'Contact Us - AWG Carbon Calculator',
		}
	},
	{
		path: '/instructions',
		name: 'Instructions',
		component: Instructions,
		meta: {
			title: 'Instructions - AWG Carbon Calculator',
		}
	},
	{
		path: '/demo',
		name: 'Demo',
		component: Demo,
		meta: {
			title: 'Demo - AWG Carbon Calculator',
		}
	},
	{
		path: '/pricing',
		name: 'Pricing',
		component: Pricing,
		meta: {
			title: 'Pricing - AWG Carbon Calculator',
		}
	},
	{
		path: '/agreement',
		name: 'Agreement',
		component: HasAgreed,
		meta: {
			title: 'Agreement - AWG Carbon Calculator',
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash,
				offset: { x: 0, y: 150 }
			}
		}
		else {
			return { x: 0, y: 0 }
		}
	}
})

import roles from "@/roles.ts";

router.beforeEach(async (to, from, next) => {

	if (Store.getters.bus === undefined) {
		Store.dispatch('init', {
			context: router.app
		});
	}

	if (to.name == "Instructions" || to.name == "Pricing" || to.name == "About" || to.name == "ContactUs" || to.name == "Demo" || to.name == "Results") {
		next();
		return;
	}

	if (Store.getters.user && Store.getters.isLoggedIn && Store.getters.user.HasAgreedACC == null && to.name != "Agreement") {
		//console.log("agree")
		next({ name: "Agreement" });
		return;
	}

	if (Store.getters.user && Store.getters.isLoggedIn && Store.getters.hasAccess == false && to.name != "Checkout" && to.name != "Agreement") {
		//console.log("check")
		next({ name: "Checkout" });
		return;
	}

	if (to.name != "Login" && to.name != "ForgotPassword" && to.name != "ResetPassword" && to.name != "Instructions" && to.name != "Agreement" && !router.app.$store.getters.isLoggedIn) {
		next({ name: 'Login' });
		return;
	}
	//else if (to.name != "Login" && to.name != "ForgotPassword" && to.name != "ResetPassword" && to.name != "Agreement" && to.name != "Instructions" && router.app.$store.getters.isLoggedIn) {
	//	try {
	//		//@ts-ignore
	//		await router.app.$http.get("/api/authentication/isLoggedIn");
	//	}
	//	catch (err) {

	//	}
	//}

	next();
});


const DEFAULT_TITLE = 'AWG Carbon Calculator';
router.afterEach((to, from) => {
	Vue.nextTick(() => {
		if (to && to.meta && to.meta.title)
			document.title = to.meta.title;
		else
			document.title = DEFAULT_TITLE;
	});

	var self = router.app;
	//@ts-ignore
	if (self.$login) {
		//@ts-ignore
		self.$login.users();
		//@ts-ignore
		self.$login.ctc();
	}
})

export default router
